import { Vitals } from "types/entity";
import { GET_VITALS_BY_TYPE, HYDRATE_VITALS, RESET_VITALS, SET_CHECKUP_VITALS, SET_VITALS_STEP } from "./constants";
import { Action, ActionWithoutPayload } from "types/redux";
import { ADD_VITALS, CREATE_VITALS, UNSET_VITALS_BY_TYPE_REDUCER, UNSET_VITALS_BY_TYPE_SAGA } from "containers/Profile/services/constants";
import { VitalsPayload } from "types/payload";
import { CheckupVitals, VitalsStore } from "types/store";

const actions = {
  getVitalsByType: (payload: { relative_id: string, type: 'weight' | 'temperature' }) => ({
    type: GET_VITALS_BY_TYPE,
    payload,
  }),
  addVitals: (payload: VitalsPayload, patient_id: number): {type: string, payload: VitalsPayload, patient_id: number } => ({
    type: ADD_VITALS,
    payload,
    patient_id
  }),
  createVitals: (payload: Vitals): Action<Vitals> => ({
    type: CREATE_VITALS,
    payload,
  }),
  unsetVitalsByTypeReducer: (payload: { type: string, patient_id: string }): Action<{type: string, patient_id: string}> => ({
    type: UNSET_VITALS_BY_TYPE_REDUCER,
    payload,
  }),
  unsetVitalsByTypeSaga: (payload: { type: string}): Action<{type: string}> => ({
    type: UNSET_VITALS_BY_TYPE_SAGA,
    payload,
  }),
  hydrateVitals: (payload: Partial<VitalsStore>): Action<Partial<VitalsStore>> => ({
    type: HYDRATE_VITALS,
    payload,
  }),
  setVitalsStep: (step?: number): Action<number | undefined> => ({
    type: SET_VITALS_STEP,
    payload: step,
  }),
  resetVitals: (): ActionWithoutPayload => ({
    type: RESET_VITALS,
  }),
  markCheckupVitals: (patientId: number, types: string[]): Action<CheckupVitals> => ({
    type: SET_CHECKUP_VITALS,
    payload: { patientId, types },
  }),

}

export default actions;